import React from 'react';
import PropTypes from 'prop-types';

export default class CircularProgressIndicator extends React.Component {
  static propTypes = {
    value: PropTypes.number,
    max_value: PropTypes.number,
    show_as_percent: PropTypes.bool,
    strokeWidth: PropTypes.number,
    radius: PropTypes.number,
    statusClass: PropTypes.string
  };

  static defaultProps = {
    strokeWidth: 4,
    radius: 26,
    max_value: 100,
    show_as_percent: true
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {

    let progress = Math.round((this.props.value / this.props.max_value) * 100);
    if (isNaN(progress)) progress = 0;
    let circle_label = this.props.value;
    if(this.props.show_as_percent) {
      circle_label = progress + "%";
    }

    const radius = this.props.radius - this.props.strokeWidth / 2;
    const width = this.props.radius * 2;
    const height = this.props.radius * 2;
    const viewBox = `0 0 ${width} ${height}`;
    const dashArray = radius * Math.PI * 2;
    const dashOffset = dashArray - dashArray * progress / 100;

    return (
      <svg
        className="CircularProgress"
        width={this.props.radius * 2}
        height={this.props.radius * 2}
        viewBox={viewBox}>
        <circle
          className={this.props.statusClass ? "CircularProgress-Bg " + this.props.statusClass : "CircularProgress-Bg"}
          cx={this.props.radius}
          cy={this.props.radius}
          r={radius}
          strokeWidth={`${this.props.strokeWidth}px`} />
        <circle
          className={this.props.statusClass ? "CircularProgress-Fg " + this.props.statusClass : "CircularProgress-Fg"}
          cx={this.props.radius}
          cy={this.props.radius}
          r={radius}
          strokeWidth={`${this.props.strokeWidth}px`}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset
          }}
          transform={`rotate(-90 ${this.props.radius} ${this.props.radius})`}
        />
        <text
          className="CircularProgress-Text"
          x={this.props.radius}
          y={this.props.radius}
          dy=".4em"
          textAnchor="middle">
          {circle_label}
        </text>
      </svg>
    );
  }
}
